/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-03 11:24:55
 * Copyright 2022 Leedarson, All Rights Reserved.
 */

const MD5 = require('md5.js');

const encryptMd5 = (str: string) => {
  const md5 = new MD5();
  md5.end(str);
  return md5.read().toString('hex');
};

export default encryptMd5;
